import { render, staticRenderFns } from "./errFixed.vue?vue&type=template&id=25624bda&scoped=true&"
import script from "./errFixed.vue?vue&type=script&lang=js&"
export * from "./errFixed.vue?vue&type=script&lang=js&"
import style0 from "./errFixed.vue?vue&type=style&index=0&id=25624bda&lang=scss&scoped=true&"
import style1 from "./errFixed.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25624bda",
  null
  
)

export default component.exports